import React from 'react';
import ReportsView from "../../layouts/ReportsView";
import ReturnsView from "../../layouts/ReturnsView";
import PayoutsView from "../../layouts/PayoutsView";
import ConfigView from "../../layouts/ConfigView";
import {Route, Switch} from "react-router-dom";
import '../../resources/stylesheets/main.css';
import HomeContainer from "../../containers/HomeContainer";
import ClientsView from "../../layouts/ClientsView";

const MainContainer = ({match}) => {

  const MAIN_CONTAINER_ROUTES = [

    {
      path: `**/reports`,
      exact: true,
      component: props => (
        <ReportsView {...props}/>
      )
    },
    {
      path: '**/returns',
      exact: true,
      component: props => (
        <ReturnsView {...props}/>
      )
    },
    {
      path: '**/payouts',
      exact: true,
      component: props => (
        <PayoutsView {...props}/>
      )
    },
    {
      path: '**/config',
      exact: true,
      component: props => (
        <ConfigView  {...props}/>
      )
    },
    {
      path: '**/clients',
      exact: true,
      component: props => (
        <ClientsView/>
      )
    },
    {
      path: '',
      exact: true,
      component: props => (
        <HomeContainer/>
      )
    }
  ];

  return (
    <Switch>
      {MAIN_CONTAINER_ROUTES.map((route, index) => <Route key={`nested${index}`} {...route} />)}
    </Switch>
  );

};

export default MainContainer;
